import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { SiteNav } from './SiteNav';

/**
 * Layout — sets the per-page accent palette via [data-accent] on <html>,
 * renders the sticky site nav, and provides a centred content column.
 *
 * Props:
 *   - accent: slug whose colours to apply (e.g. 'ph', 'wl', 'tls')
 *   - title: page title (sets <title>)
 *   - children: page contents
 */
export function Layout({ accent = 'index', title, children }) {
  useEffect(() => {
    document.documentElement.setAttribute('data-accent', accent);
    if (title) document.title = `${title} · Field Notes`;
    return () => {
      document.documentElement.setAttribute('data-accent', 'index');
    };
  }, [accent, title]);

  return (
    <div className="paper-bg paper-noise min-h-screen">
      <SiteNav />
      <main className="relative z-10 mx-auto max-w-page px-8 pb-24">
        {children}
      </main>
      <footer className="no-print mx-auto max-w-page px-8 py-10 border-t-2 border-ink/30 mt-24 font-mono text-[11px] text-ink-muted tracking-wider flex justify-between flex-wrap gap-3">
        <span>© Marouane BENALLA · Compiled 2026</span>
        <Link to="/" className="text-accent no-underline">← back to index</Link>
      </footer>
    </div>
  );
}
